import {HttpInterceptorFn} from "@angular/common/http";
import {environment} from "../../environments/environment";

export const apiGatewayHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiGateway)) {
    const newRequest = req.clone({
      setHeaders: {
        "X-NG-Gateway": environment.apiGatewayHeader
      }
    });
    return next(newRequest);
  }

  return next(req);

};
